import {allRequest, getRequest, postRequest, REQUEST_METHOD_GET, REQUEST_METHOD_POST} from "../../../middlewares/api/actions";
import {
  getAgencyNamesUrl,
  getCreateArtefactsUrl,
  getCsvTablePreviewUrl,
  getDataflowUrl,
  getDsdUrl,
  getGenerateCCFromFileUrl,
  getUploadFileOnServerUrl
} from "../../../constants/urls";
import {getSdmxJsonFromSdmxJsonStructures, getSdmxJsonStructureFromContentConstraint, SDMX_JSON_CONTENT_CONSTRAINT_LIST_KEY} from "../../../utils/sdmxJson";

export const GENERATE_CC_FROM_FILE_AGENCIES_READ = "GENERATE_CC_FROM_FILE_AGENCIES_READ";

export const GENERATE_CC_FROM_FILE_CC_CHANGE = "GENERATE_CC_FROM_FILE_CC_CHANGE";
export const GENERATE_CC_FROM_FILE_CC_RESET = "GENERATE_CC_FROM_FILE_CC_RESET";
export const GENERATE_CC_FROM_FILE_CC_SUBMIT = "GENERATE_CC_FROM_FILE_CC_SUBMIT";

export const GENERATE_CC_FROM_FILE_CC_ARTEFACT_TYPE_SET = "GENERATE_CC_FROM_FILE_CC_ARTEFACT_TYPE_SET";
export const GENERATE_CC_FROM_FILE_CC_ARTEFACTS_READ = "GENERATE_CC_FROM_FILE_CC_ARTEFACTS_READ";
export const GENERATE_CC_FROM_FILE_CC_ARTEFACTS_HIDE = "GENERATE_CC_FROM_FILE_CC_ARTEFACTS_HIDE";
export const GENERATE_CC_FROM_FILE_CC_ARTEFACT_SET = "GENERATE_CC_FROM_FILE_CC_ARTEFACT_SET";

export const GENERATE_CC_FROM_FILE_FILE_FORM_CHANGE = "GENERATE_CC_FROM_FILE_FILE_FORM_CHANGE";
export const GENERATE_CC_FROM_FILE_FILE_UPLOAD = "GENERATE_CC_FROM_FILE_FILE_UPLOAD";

export const GENERATE_CC_FROM_FILE_CSV_ROWS_SHOW = "GENERATE_CC_FROM_FILE_CSV_ROWS_SHOW";
export const GENERATE_CC_FROM_FILE_CSV_ROWS_HIDE = "GENERATE_CC_FROM_FILE_CSV_ROWS_HIDE";
export const GENERATE_CC_FROM_FILE_CSV_ROWS_READ = "GENERATE_CC_FROM_FILE_CSV_ROWS_READ";

export const readGenerateCCFromFileAgencies = allowedAgencies => ({
  ...getRequest(
    GENERATE_CC_FROM_FILE_AGENCIES_READ,
    getAgencyNamesUrl()
  ),
  allowedAgencies
});

export const changeGenerateCCFromFileCC = fields => ({
  type: GENERATE_CC_FROM_FILE_CC_CHANGE,
  fields
});

export const resetGenerateCCFromFileCC = () => ({
  type: GENERATE_CC_FROM_FILE_CC_RESET
});

export const submitGenerateCCFromFileCC = (contentConstraint, artefactType, artefactUrn, filePath, separator, delimiter) => allRequest(
  GENERATE_CC_FROM_FILE_CC_SUBMIT,
  [REQUEST_METHOD_POST, REQUEST_METHOD_GET],
  [getCreateArtefactsUrl(), getGenerateCCFromFileUrl(contentConstraint, filePath, separator, delimiter)],
  [
    getSdmxJsonFromSdmxJsonStructures(
      [
        getSdmxJsonStructureFromContentConstraint(
          contentConstraint,
          artefactType,
          artefactUrn,
          null,
          null
        )
      ],
      SDMX_JSON_CONTENT_CONSTRAINT_LIST_KEY
    ),
    undefined
  ],
  t => ({
    success: t('scenes.utilities.generateCCFromFile.messages.create.success')
  }),
  undefined,
  true
);

export const setGenerateCCFromFileArtefactType = artefactType => ({
  type: GENERATE_CC_FROM_FILE_CC_ARTEFACT_TYPE_SET,
  artefactType
});

export const readGenerateCCFromFileArtefacts = artefactType => getRequest(
  GENERATE_CC_FROM_FILE_CC_ARTEFACTS_READ,
  artefactType === "dataflow"
    ? getDataflowUrl()
    : getDsdUrl()
);

export const hideGenerateCCFromFileArtefacts = () => ({
  type: GENERATE_CC_FROM_FILE_CC_ARTEFACTS_HIDE
});

export const setGenerateCCFromFileArtefact = artefact => ({
  type: GENERATE_CC_FROM_FILE_CC_ARTEFACT_SET,
  artefact
});

export const changeGenerateCCFromFileFileForm = fields => ({
  type: GENERATE_CC_FROM_FILE_FILE_FORM_CHANGE,
  fields
});

export const uploadGenerateCCFromFileFile = file => {

  let fileFormData = new FormData();
  fileFormData.append('file', file);

  return postRequest(
    GENERATE_CC_FROM_FILE_FILE_UPLOAD,
    getUploadFileOnServerUrl(),
    fileFormData,
    t => ({
      start: t('scenes.utilities.generateCCFromFile.messages.submit.start'),
      success: t("scenes.utilities.generateCCFromFile.messages.submit.success")
    })
  );
};

export const showGenerateCCFromFileCsvRows = () => ({
  type: GENERATE_CC_FROM_FILE_CSV_ROWS_SHOW
});

export const hideGenerateCCFromFileCsvRows = () => ({
  type: GENERATE_CC_FROM_FILE_CSV_ROWS_HIDE
});

export const readGenerateCCFromFileCsvRows = (
  pageNum,
  pageSize,
  filterTable,
  sortCols,
  sortByDesc,
  separator,
  delimiter,
  hasHeader,
  tid,
  filePath,
  idMappingSpecialTimePeriod
) => postRequest(
  GENERATE_CC_FROM_FILE_CSV_ROWS_READ,
  getCsvTablePreviewUrl(separator, delimiter, hasHeader, filePath, tid, idMappingSpecialTimePeriod),
  {
    PageNum: pageNum,
    PageSize: pageSize,
    FilterTable: filterTable,
    SortCols: sortCols,
    SortByDesc: sortByDesc
  }
);